import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnZA: CultureInfo = {
  name: 'en-ZA',
  displayName: 'English (South Africa)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-ZA',
  parent: CultureInfoEn
};
